/**************************************************
 * Nombre:       Seccion_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {CASILLA_FECHA_DATO, CASILLA_TEXTO} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext, useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {usuarioContext} from "../../App";
import {where} from "firebase/firestore";
import Tabla_Soporte from "../../Modulo_Tabla_2025/Componentes/Tabla_Soporte";
import Dialogo_Soporte from "../Dialogos/Dialogo_Soporte";
import Dialogo_Soporte_Ver from "../Dialogos/Dialogo_Soporte_Ver";
import {irArriba} from "../../Utilidades/irArriba";


const Seccion_Soporte = () => {
    const cData = useContext(usuarioContext)
    const [wheres, setWheres] = useState([where('idUsuario', '==', cData.usuario.id)])
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'soportes', wheres: wheres})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Soporte,
        titulo: 'Detalles de soporte',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoVer, abrir: abrirVer} = useDialogo({
        Componente: Dialogo_Soporte_Ver,
        titulo: 'Detalles de soporte',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrirVer(data)
                break
            default :
                abrir(data)
        }
    }

    useEffect(() => {
        irArriba()
    },[])
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoVer/>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                    <Tabla_Soporte
                        nombre={'Lista de peticiones y administradores'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Soporte

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Número y Fecha',
        direccion: 'left',
        propiedad: 'consecutivo',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Asunto',
        direccion: 'left',
        propiedad: 'asunto',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',
        fecha: 'fechaRespuesta',
        tipo: CASILLA_FECHA_DATO,
    }

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]